import React from 'react';

function DeleteModal({ text, funct }) {
  return (
    <div className="fixed top-0 left-0 h-screen w-screen bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 max-w-md w-full mx-4 border border-gray-300 rounded-lg shadow-xl">
       
        <div className="flex items-center justify-center mb-4">
          <div className="rounded-full bg-red-100 p-3">
            <svg className="w-8 h-8 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
            </svg>
          </div>
        </div>
        
        
        <div className="text-center mb-6">
          <h3 className="text-lg font-medium text-gray-900 mb-2">Confirm Deletion</h3>
          <p className="text-gray-600">{text}</p>
          <p className="text-sm text-red-600 mt-2">This action cannot be undone.</p>
        </div>
        
       
        <div className="flex justify-center space-x-4">
          <button
            className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded transition-colors focus:outline-none focus:ring-2 focus:ring-gray-400"
            onClick={() => {
              funct(false);
            }}
          >
            Cancel
          </button>
          <button
            className="flex-1 bg-red-500 hover:bg-red-600 text-white font-medium py-2 px-4 rounded transition-colors focus:outline-none focus:ring-2 focus:ring-red-400"
            onClick={() => {
              funct(true);
            }}
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteModal;